import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authFetch } from '../../services/api';

/** Signed-in-only Contact support + optional System status (when STATUS_PAGE_URL is set). */
export default function SupportFooterLinks() {
  const { user } = useAuth();
  const [statusPageUrl, setStatusPageUrl] = useState(null);

  useEffect(() => {
    if (!user) {
      setStatusPageUrl(null);
      return;
    }
    let cancelled = false;
    authFetch('/api/support/config')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data?.statusPageUrl) {
          setStatusPageUrl(data.statusPageUrl);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (!user) return null;

  return (
    <p className="text-slate-600 text-[10px] space-x-2">
      <Link to="/support" className="hover:text-emerald-400">
        Contact support
      </Link>
      {statusPageUrl && (
        <>
          <span>·</span>
          <a
            href={statusPageUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-emerald-400"
          >
            System status
          </a>
        </>
      )}
    </p>
  );
}
